import { TrendingUp } from "@raresail/react-ionicons";
import styled from "styled-components";
import { currencyFormat } from "../../../utils/helpers";
import { Heading } from "../../elements/Elements";
import { useAuth } from "../../context/AuthContext";
import { primary5 } from "../../../constants/colors";

export const InvestorBalanceCard = () => {
  const { user } = useAuth();

  const portfolioBalance = parseFloat(user?.portfolio_balance || "0");
  const netInterest = parseFloat(user?.net_interest_earned || "0");

  return (
    <Wrapper className="r15 whiteBg flexColumn gap15">
      <Heading className="font14">Your Holdings</Heading>

      <div className="flexColumn gap10">
        <Item
          label="Portfolio Balance"
          value={currencyFormat(portfolioBalance)}
          color="#1565c0"
        />
        <Item
          label="Interest Earned"
          value={currencyFormat(netInterest)}
          color="#2e7d32"
        />
      </div>
    </Wrapper>
  );
};

const Item = ({
  label,
  value,
  color,
}: {
  label: string;
  value: any;
  color: string;
}) => (
  <ItemWrapper style={{ borderLeft: `3px solid ${color}` }}>
    <div className="flexNullCenter gap5 grey mb5">
      <div className="font12 capitalize">{label}</div>
      <TrendingUp />
    </div>
    <div className="font16 bold textDark">{value}</div>
  </ItemWrapper>
);

const Wrapper = styled.div`
  padding: 18px;
  border: 1px solid ${primary5};
`;

const ItemWrapper = styled.div`
  background: ${primary5};
  padding: 14px 16px;
  border-radius: 12px;
`;